import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowDown, ArrowUp, ArrowUpDown, Filter, X } from "lucide-react";
import { ORIGEM_KEYS, ORIGEM_META } from "./backupOrigem";

const STATUS_OPTS = [["success", "Sucesso"], ["error", "Erro"], ["running", "Rodando"], ["unknown", "Legado"]];

// Barra de filtros do histórico de backups (empresa opcional + período + status + origem) e cabeçalho ordenável.
export function BackupHistoryFilters({ f, empresas = null, total, shown }) {
  return (
    <div className="flex flex-wrap items-end gap-2" data-testid="backup-history-filters" data-active={f.active}>
      <Filter className="w-4 h-4 text-slate-500 mb-2" />
      {empresas && (
        <div>
          <label className="text-[11px] text-muted-foreground block mb-1">Empresa</label>
          <Select value={f.empresaId} onValueChange={f.setEmpresaId}>
            <SelectTrigger className="h-9 w-[200px]" data-testid="hist-filter-empresa"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todas as empresas</SelectItem>
              {empresas.map((e) => <SelectItem key={e.id} value={e.id} data-testid={`hist-filter-empresa-opt-${e.id}`}>{e.nome}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      )}
      <div>
        <label className="text-[11px] text-muted-foreground block mb-1">De</label>
        <Input type="date" className="h-9 w-[150px]" value={f.start} onChange={(e) => f.setStart(e.target.value)} data-testid="hist-filter-start" />
      </div>
      <div>
        <label className="text-[11px] text-muted-foreground block mb-1">Até</label>
        <Input type="date" className="h-9 w-[150px]" value={f.end} onChange={(e) => f.setEnd(e.target.value)} data-testid="hist-filter-end" />
      </div>
      <div>
        <label className="text-[11px] text-muted-foreground block mb-1">Status</label>
        <Select value={f.status} onValueChange={f.setStatus}>
          <SelectTrigger className="h-9 w-[130px]" data-testid="hist-filter-status"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos</SelectItem>
            {STATUS_OPTS.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`hist-filter-status-opt-${v}`}>{l}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <label className="text-[11px] text-muted-foreground block mb-1">Origem</label>
        <Select value={f.origem} onValueChange={f.setOrigem}>
          <SelectTrigger className="h-9 w-[230px]" data-testid="hist-filter-origem"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todas</SelectItem>
            {ORIGEM_KEYS.map((k) => <SelectItem key={k} value={k} data-testid={`hist-filter-origem-opt-${k}`}>{ORIGEM_META[k].label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {f.active > 0 && (
        <Button size="sm" variant="ghost" className="h-9" onClick={f.clear} data-testid="hist-filter-clear">
          <X className="w-3.5 h-3.5 mr-1" />Limpar
        </Button>
      )}
      <span className="text-[11px] text-muted-foreground mb-2 ml-auto" data-testid="hist-filter-count">
        {f.invalid ? <span className="text-rose-600">Data inicial maior que a final</span> : `${shown} de ${total} registro(s)`}
      </span>
    </div>
  );
}

export function SortableDateHeader({ sortDir, onToggle, className = "px-4 py-2 font-semibold" }) {
  const Icon = sortDir === "asc" ? ArrowUp : sortDir === "desc" ? ArrowDown : ArrowUpDown;
  return (
    <th className={className}>
      <button type="button" onClick={onToggle} className="inline-flex items-center gap-1 hover:text-indigo-700"
        title={sortDir === "desc" ? "Mais recente primeiro — clique para inverter" : "Mais antigo primeiro — clique para inverter"}
        data-testid="hist-sort-date" data-dir={sortDir}>
        Data <Icon className="w-3.5 h-3.5" />
      </button>
    </th>
  );
}
